import publicConfig from 'common/core/publicConfig';
import devURL from 'common/util/devURL';

import Message from './message/Message';
import queryString from './util/queryString';

const GoogleAuthURL = 'https://accounts.google.com/o/oauth2/v2/auth';
// NOTE: Not using devURL() here as Google OAuth requires exact matching URIs.
// localhost:8007/auth would not match what's registered in Google Console.
const RedirectURI = __DEV__ ? 'https://canny.io/auth' : devURL('https://canny.io/auth');
const Origin = devURL('https://canny.io');

export default class OAuthGoogle {
  constructor({ onSuccess, onFailure, onContinue, shouldOpenNewTab, redirectURL, separateWindow }) {
    this._onFailure = onFailure;
    this._onContinue = onContinue;
    this._redirectURL = redirectURL;
    this._separateWindow = separateWindow;
    this._shouldOpenNewTab = shouldOpenNewTab;
  }

  connect = () => {
    const url =
      GoogleAuthURL +
      queryString.stringify({
        client_id: publicConfig('googleOauthClientID'),
        redirect_uri: RedirectURI,
        response_type: 'code',
        scope: 'openid profile email',
        state: this.getState(),
      });

    if (!this._shouldOpenNewTab) {
      window.location = url;
      return;
    }

    // No, 'noopener' because we trust Google
    const authWindow = window.open(url, 'Canny Authentication');
    const unsubscribe = Message.subscribe(authWindow, Origin, 'authResult', (result) => {
      this._onContinue(result);
      unsubscribe();
    });
  };

  getState = () => {
    const params = {
      authType: 'google',
      stage: 2,
      ...(this._shouldOpenNewTab && { close: true }),
      ...(this._redirectURL && { redirectURL: encodeURIComponent(this._redirectURL) }),
      ...(this._separateWindow && { separateWindow: encodeURIComponent(this._separateWindow) }),
      ...(__DEV__ && {
        dev: true,
      }),
    };
    return JSON.stringify(params);
  };
}
